import LegalPage from "../legal/LegalPage";

const content = {
    ar: {
        title: "سياسة الاسترجاع والاستبدال",
        lastUpdated: "آخر تحديث: أغسطس 2026",
        sections: [
            {
                heading: "مدة الاسترجاع",
                paragraphs: [
                    "يمكنك طلب استرجاع أو استبدال المنتج خلال [14] يومًا من تاريخ استلام الطلب، بشرط أن يكون المنتج بحالته الأصلية وغير مستخدم وبكامل عبوته الأصلية.",
                ],
            },
            {
                heading: "المنتجات غير القابلة للاسترجاع",
                list: [
                    "المنتجات التي تم استخدامها أو إتلاف عبوتها الأصلية",
                    "المنتجات المخصصة حسب الطلب",
                    "منتجات العناية الشخصية لأسباب صحية (ما لم تكن العبوة مغلقة وسليمة)",
                ],
            },
            {
                heading: "خطوات طلب الاسترجاع",
                list: [
                    "تواصل معنا عبر البريد الإلكتروني أو صفحة التواصل خلال المدة المحددة",
                    "أرفق رقم الطلب وسبب الاسترجاع",
                    "سيتم إعلامك بحالة الموافقة خلال 2-3 أيام عمل",
                    "بعد الموافقة، أعد المنتج بالعبوة الأصلية إلى العنوان الذي سنرسله لك",
                ],
            },
            {
                heading: "استرداد المبلغ",
                paragraphs: [
                    "بعد استلام المنتج المرتجع والتأكد من حالته، سيتم استرداد المبلغ إلى نفس وسيلة الدفع الأصلية خلال 5-10 أيام عمل. في حالة الدفع عند الاستلام، سيتم التنسيق معك بخصوص طريقة الاسترداد.",
                ],
            },
            {
                heading: "تكاليف الشحن للإرجاع",
                paragraphs: [
                    "في حالة كون سبب الإرجاع خطأً من طرفنا (منتج تالف أو مختلف عن الطلب)، نتحمل تكلفة الشحن بالكامل. في الحالات الأخرى، يتحمل العميل تكلفة شحن الإرجاع.",
                ],
            },
        ],
    },
    en: {
        title: "Return & Refund Policy",
        lastUpdated: "Last updated: August 2026",
        sections: [
            {
                heading: "Return Window",
                paragraphs: [
                    "You may request a return or exchange within [14] days of receiving your order, provided the product is in its original condition, unused, and in its original packaging.",
                ],
            },
            {
                heading: "Non-Returnable Items",
                list: [
                    "Products that have been used or whose original packaging has been damaged",
                    "Custom-made or personalized products",
                    "Personal care items for hygiene reasons (unless the seal is intact)",
                ],
            },
            {
                heading: "How to Request a Return",
                list: [
                    "Contact us via email or the contact page within the specified window",
                    "Include your order number and reason for return",
                    "You'll be notified of approval status within 2–3 business days",
                    "Once approved, return the item in its original packaging to the address we provide",
                ],
            },
            {
                heading: "Refunds",
                paragraphs: [
                    "Once we receive and inspect the returned item, your refund will be processed to your original payment method within 5–10 business days. For Cash on Delivery orders, we will coordinate the refund method with you directly.",
                ],
            },
            {
                heading: "Return Shipping Costs",
                paragraphs: [
                    "If the return is due to our error (damaged or incorrect item), we cover the full shipping cost. In other cases, the customer is responsible for return shipping costs.",
                ],
            },
        ],
    },
};

export default function RefundPolicy ()
{
    return <LegalPage content={ content } />;
}
